import React from 'react'
import { Divider, Typography } from 'antd'
import BinStatus from '../../../components/EOL/BinStatus/BinStatus'

const EOL_BinStatusPage = ({ userData }) => {
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    Bin Status
                </Typography.Title>
            </div>
            <Divider style={{ marginTop: 8 }} />
            <BinStatus />
        </>
    )
}

export default EOL_BinStatusPage